module.exports = __webpack_public_path__ + "static/Graphik-Semibold-Cy-Web-f954bdc2e45d58f29b99c9548449e4ba.woff2";